import { FC, useEffect, useState } from 'react'

import css from './Loader.styles.scss'
import classNames from 'classnames'

interface LoaderProps {
  loading: boolean
}

const Loader: FC<LoaderProps> = ({ children, loading }) => {
  const [removeOverlay, setRemoveOverlay] = useState(false)

  useEffect(() => {
    if (!loading && !removeOverlay) {
      setTimeout(() => {
        setRemoveOverlay(true)
      }, 600) // wait for opacity transition to finish
    }
  }, [loading])

  return (
    <>
      <div
        className={classNames(css.Loader__overlay, {
          [css['Loader__overlay--hidden']]: !loading,
          [css['Loader__overlay--removed']]: removeOverlay,
        })}
      />
      {children}
    </>
  )
}

export default Loader
